import { PlatformPermissions } from '@/constants/platformPermissions';
import { useAuth } from '@/context/auth';

export const useHasTeamsPermissions = (requiredPermissions: PlatformPermissions[]) => {
  const { userTeamsPermissions } = useAuth();

  return requiredPermissions.every((permission) => userTeamsPermissions.includes(permission));
};
